import * as IconSelector from '../icons';

// Constantes exportadas
export const STATE_RESOLUTION_POR_RESOLVER = 'Por Resolver';
export const STATE_RESOLUTION_EN_CURSO = 'En Curso';
export const STATE_RESOLUTION_RESUELTO = 'Resuelto';
export const STATE_RESOLUTION_RECHAZADO = 'Rechazado';

// Definición del enum
export const statesResolution = [
    {
        value: null,
        label: 'Sin definir',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_RESOLUTION_POR_RESOLVER,
        label: 'Por Resolver',
        description: 'Pendiente de Resolución',
        icon: IconSelector.ToVerifiedIcon,
        color: 'Blue'
    },
    {
        value: STATE_RESOLUTION_EN_CURSO,
        label: 'En Curso',
        description: 'Realizandose atualmente',
        icon: IconSelector.DoIcon,
        color: 'DarkOrange'
    },
    {
        value: STATE_RESOLUTION_RESUELTO,
        label: 'Resuelto',
        description: 'Resolución favorable',
        icon: IconSelector.VerifiedIcon,
        color: 'Green'
    },
    {
        value: STATE_RESOLUTION_RECHAZADO,
        label: 'Rechazado',
        description: 'Resolución no favorable',
        icon: IconSelector.RejectIcon,
        color: 'DarkRed'
    }
];
